module.exports = __webpack_public_path__ + "img/立即签到.651a2e36.svg";